<template>
  <div class="hello">

    <b-container>
        <b-row>
            <b-col style="color:red"> * = required</b-col>
        </b-row>

        <b-row>
            <b-col>
                <!-- Use lazy so message shows once user has stopped typing -->
                <b-input-group prepend="Company *" class="mt-3">
                    <b-form-input v-model="$v.contactForm.company.$model" @input="checkForm"></b-form-input>
                </b-input-group>
                <p class="error" v-if="!$v.contactForm.company.minLength">Must have at least {{ $v.contactForm.company.$params.minLength.min }} characters.</p>
                <p class="error" v-if="!$v.contactForm.company.required">this field is required</p>

                <b-input-group prepend="Contact Name *" class="mt-3">
                    <b-form-input v-model="$v.contactForm.contactname.$model" @input="checkForm"></b-form-input>
                </b-input-group>
                <p class="error" v-if="!$v.contactForm.contactname.minLength">Must have at least {{ $v.contactForm.contactname.$params.minLength.min }} characters.</p>


                <b-input-group prepend="Phone *" class="mt-3">
                    <b-form-input v-model="$v.contactForm.phone.$model" @input="checkForm"></b-form-input>
                </b-input-group>
                <p class="error" v-if="!$v.contactForm.phone.phonevalidator">Invalid phone number.</p>


                <b-input-group prepend="Street1 *" class="mt-3">
                    <b-form-input v-model="$v.contactForm.street1.$model" @input="checkForm"></b-form-input>
                </b-input-group>
                <p class="error" v-if="!$v.contactForm.street1.minLength">Must have at least {{ $v.contactForm.street1.$params.minLength.min }} characters.</p>
                
                <b-input-group prepend="Street2" class="mt-3">
                    <b-form-input v-model="$v.contactForm.street2.$model" @input="checkForm"></b-form-input>
                </b-input-group>
                <b-input-group prepend="City *" class="mt-3">
                    <b-form-input v-model="$v.contactForm.city.$model" @input="checkForm"></b-form-input>
                </b-input-group>
                <p class="error" v-if="!$v.contactForm.city.minLength">Must have at least {{ $v.contactForm.city.$params.minLength.min }} characters.</p>

                <b-input-group prepend="Zip *" class="mt-3">
                    <b-form-input v-model="$v.contactForm.zip.$model" @input="checkForm"></b-form-input>
                </b-input-group>
                <p class="error" v-if="!$v.contactForm.zip.zipvalidator">Invalid zip.</p>
            </b-col>
        </b-row>

        

    </b-container>
      
  </div>
</template>

<script>

import { mapState } from 'vuex'
import { required, minLength, between } from 'vuelidate/lib/validators'
import { helpers } from 'vuelidate/lib/validators'
const phonevalidator = helpers.regex('phonevalidator', /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/)

const zipvalidator = helpers.regex('zipvalidator', /^[0-9]{5}(?:-[0-9]{4})?$/)

export default {    
    props: {
    },

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser']),
        //Check if form valid

    },

    //Watch for farm data being valid
    watch: {
            userProfileStatus(newValue, oldValue) {
                /*
                if (newValue){
                    this.performingRequest = false
                    if(this.userProfile.isbrewer==1) this.$router.push('/brewerdashboard')
                    else if(this.userProfile.isbrewer==2) this.$router.push('/distributorinventory')
                    else this.$router.push('/allbeers')
                    
                }*/
            },
        },

    components: {
    },

    data() {
        return {
            contactForm:{
                company:"",
                contactname:"",
                phone:"",
                street1:"",
                street2:"",
                city:"",
                state:"",
                zip:"",
                county:"",
            },
            
        }
    },
    validations: {
        contactForm:{
            company: {
                    required,
                    minLength: minLength(4)
                },
                contactname: {
                    required,
                    minLength: minLength(4)
                },
                phone: {
                    required,
                    phonevalidator,
                },
                street1: {
                    required,
                    minLength: minLength(4)
                },
                street2: {

                },
                city: {
                    required,
                    minLength: minLength(2)
                },
                state: {

                },
                zip: {
                    required,
                    zipvalidator,

                },
            },  

        },
                 
    methods:{
        checkForm(){
            console.log("Form touched: " + this.$v.contactForm.$anyDirty)
            console.log("Form error: " + this.$v.contactForm.$anyError)
            console.log("Form invalid: " + this.$v.contactForm.$invalid)
            if(!this.$v.contactForm.$invalid) this.$emit('can-continue', {value: true});
            else this.$emit('can-continue', {value: false});
        },
    },

    mounted(){
    },
}
</script>

<style scoped>
.error {
  color: red;
  font-size:12px;
}

</style>

